module.exports = __webpack_public_path__ + "img/PIRATE_LEGENDARY 1.746ef87b.jpg";